
import { computed, defineComponent, inject, onMounted, provide, ref, useCssModule } from 'vue'
import { useIdentity } from '@/composables/useIdentity'
import Navbar from '@/components/Navbar.vue'
import Card from '@/components/Card.vue'
import Notifications from '@/components/Notifications.vue'
import LoginPage from '@/pages/LoginPage.vue'
import GreetingPage from '@/pages/GreetingPage.vue'
import RegisterPage from '@/pages/RegisterPage.vue'
import ChangeBranchPage from '@/pages/ChangeBranchPage.vue'

const pages = [
	{ id: 'info', name: '我的資料' },
	{ id: 'order', name: '我的訂單' },
]

export default defineComponent({
	components: {
		Navbar,
		Card,
		LoginPage,
		Notifications,
		GreetingPage,
		RegisterPage,
		ChangeBranchPage,
	},
	setup() {
		const initialized = inject('appInitialized', false)
		const identity = useIdentity()
		const currentPage = ref('greeting')

		provide('globalStyle', useCssModule('global'))
		onMounted(() => $(document).trigger('vueApp:mounted'))

		return {
			style: useCssModule(),
			initialized,
			identity,
			pages,
			currentPage: computed({
				get: () => (
					identity.isRegistered ? currentPage.value : 'register'
				),
				set(v) {
					currentPage.value = v
				},
			}),
		}
	},
})
